import { useCallback } from "react";
import { searchLayers } from "api/layerService";

const useFetchLayers = () => {
  const fetchLayersByTemplateId = useCallback(async (templateId, setLayers) => {
    if (!templateId) return;

    const res = await searchLayers({ templateId, isPaging: false });
    if (res?.success !== false) {
      setLayers(res?.object || []);
    } else {
      console.error("Không thể load danh sách layer:", res?.message);
    }
  }, []);

  return { fetchLayersByTemplateId };
};

export default useFetchLayers;
